export const TITULO_PAGINA = 'Trocar forma de pagamento'

export const TEXTO_MODAL_EXCLUSAO_CARTAO = 'Você tem certeza que deseja excluir este cartão?'

export const TITULO_ADICIONAR_CARTAO = 'Adicionar cartão de crédito'

export const MODAL_CANCELAR = 'Cancelar'

export const MODAL_CONFIRMAR = 'Confirmar'

export const TITULO_ERRO_SALVAR_CARTAO_CREDITO = 'Sua transação foi recusada.'

export const HELPER_TEXT = {
  'texto': 'Nosso sistema ainda está validando o seu cartão, esse processo pode demorar alguns segundos, atualize a página e tente novamente.',
  'titulo': 'Cadastrei um novo cartão e não aparece para tornar como vigente.',
}
